<template>
  <div class="mobilePage" @click="pageClick">
    <div class="headerBox">
      <div
        class="logo"
        @click.stop="
          getApkInfo(
            os.isPhone && switchData.shopIosDownUrl ? 'shopIos' : true,
            $event,
          )
        "
      >
        <div class="logoIcon"></div>
        <div class="logoInfo">
          <div class="logoName">黄果短剧</div>
          <div class="logoSlogan">亚洲最火网站 AI成人短剧</div>
        </div>
      </div>
      <div class="headerLinks">
        <div class="linkItem" v-if="cTg" @click.stop="jumpUrl(cTg)">
          <div class="telegram"></div>
          <span>TG</span>
        </div>
        <div class="linkItem" v-if="cBusiness" @click.stop="jumpUrl(cBusiness)">
          <div class="business"></div>
          <span>商务</span>
        </div>
        <div class="linkItem" v-if="cChannel" @click.stop="jumpUrl(cChannel)">
          <div class="channel"></div>
          <span>渠道</span>
        </div>
        <div class="linkItem" @click.stop="openOnlineService($event)">
          <div class="customer"></div>
          <span>客服</span>
        </div>
      </div>
    </div>
    <div class="banner-box">
      <div
        class="banner"
        @click.stop="
          getApkInfo(
            os.isPhone && switchData.shopIosDownUrl ? 'shopIos' : true,
            $event,
          )
        "
      ></div>
    </div>
    <div class="ctaBar" @click.stop="getApkInfo(true, $event)">
      <div class="ctaText">亚洲最火成人网站 真实国产原创 AI原创成人短剧</div>
      <div class="ctaBtn"></div>
    </div>

    <div
      class="main"
      @click.stop="
        getApkInfo(
          os.isPhone && switchData.shopIosDownUrl ? 'shopIos' : true,
          $event,
        )
      "
    >
      <div class="sectionBox">
        <div
          class="section"
          v-for="item in tabs"
          :key="item.value"
          :class="{ sectionActive: tabActive === item.value }"
          @click="tabActive = item.value"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="contentBox"></div>
    </div>

    <div class="bottomBox">
      <div
        class="downBtn"
        :class="os.isPhone ? 'downBtnIos' : 'downBtnAndroid'"
        @click.stop="onLiteDownload($event)"
      ></div>
      <div
        class="downBtnSpare"
        v-if="switchData.androidDownUrl && switchData.channelApkAndDownUrl"
        @click.stop="getApkInfo('androidSpare', $event)"
      >
        备用下载
      </div>
      <div class="disclaimer">
        本APP由于行业原因，会被杀毒软件误认为风险软件，需要关闭网络安装，请放心下载。APP有广告收益，因此所有资源免费观看，安装无任何风险，请放心使用。
      </div>
    </div>

    <div
      class="downloadIosAppStore"
      @click.stop="getApkInfo('shopIos', $event)"
      v-if="os.isPhone && switchData.shopIosDownUrl && showIosTip"
    >
      <div class="close-btn" @click.stop="showIosTip = false"></div>
    </div>
    <!-- 安卓提示框 -->
    <van-overlay :show="androidPromptShow" z-index="999" class="androidOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="androidPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <!-- 苹果安装引导 -->
    <ios-install-guide :show="iosPromptShow" @close="iosPromptShow = false" />
    <van-popup v-model="showTip" class="downTip">
      <div class="downTipTitle">温馨提示</div>
      <div class="downTipContent">
        请使用Safari浏览器进行下载
      </div>
      <div class="url">{{ currUrl }}</div>
      <div class="downTipConfirm" @click.stop="doCopy">复制链接</div>
    </van-popup>
  </div>
</template>

<script>
import getCustomerServiceUrl from "@/api/getCustomerServiceUrl";
import {
  getDeviceType,
  getSystemType,
  getSystemVersion,
  getTraceId,
  landingPageClick,
} from "@/utils/eventTracker";
import iosInstallGuide from "./iosInstallGuide";

const APPID = 4002;

export default {
  components: { iosInstallGuide },
  props: ["os", "configs", "switchData"],
  data() {
    return {
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      currUrl: window.location.href,
      tabActive: "short_film",
      tabs: [
        {
          label: "短剧",
          value: "short_film",
        },
        {
          label: "热门",
          value: "hot",
        },
        {
          label: "精选",
          value: "featured",
        },
        {
          label: "国产",
          value: "domestic",
        },
        {
          label: "乱伦",
          value: "darkweb",
        },
        {
          label: "动漫",
          value: "cartoon",
        },
      ],
      cTg: "",
      cPotato: "",
      cBusiness: "",
      cChannel: "",
      onlineServiceLoading: false,
      recordParam: "",
      shopIosDownUrl: "",
      showIosTip: true,
      version: "B",
    };
  },
  watch: {
    configs(configs) {
      configs.forEach((item) => {
        if (item.configType === "tg_group") {
          this.cTg = item.link;
        } else if (item.configType === "potato_group") {
          this.cPotato = item.link;
        } else if (item.configType === "sw_cooperate") {
          this.cBusiness = item.link;
        } else if (item.configType === "qd_cooperate") {
          this.cChannel = item.link;
        }
      });
      return configs;
    },
  },
  methods: {
    pageClick(event) {
      let click_coordinates_x = event.clientX;
      let click_coordinates_y = event.clientY;
      let tab_name =
        this.tabs.find((item) => item.value == this.tabActive)?.label || "";
      landingPageClick(this, {
        tab_key: this.tabActive,
        tab_name,
        click_coordinates_x,
        click_coordinates_y,
      });
    },
    checkIsSafari() {
      const ua = (this.os.userAgent || "").toLowerCase();
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1
      );
    },
    onLiteDownload(event) {
      if (this.os.isPhone && !this.checkIsSafari()) {
        this.showTip = true;
        landingPageClick(this, {
          tab_name: "下载按钮",
          tab_key: "download",
          click_coordinates_x: event.clientX,
          click_coordinates_y: event.clientY,
        });
        return;
      }
      this.getApkInfo(true, event);
    },
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          console.log("复制成功");
          this.showTip = false;
        },
        () => {
          console.log("复制失败");
        },
      );
    },
    async showInstallTutorial(type) {
      if (type == "ios") {
        this.iosPromptShow = true;
      } else {
        this.androidPromptShow = true;
      }
    },
    async getApkInfo(flag, event) {
      let type = "android";
      if (this.os.isPhone) {
        type = "ios";
        if (flag === "shopIos") {
          type = "shopIos";
        }
      } else {
        type = "android";
      }
      if (flag == "androidSpare") {
        type = "androidSpare";
      }
      if (flag && flag !== "shopIos") {
        await this.showInstallTutorial(type);
      }
      this.$emit("recordClick", type);
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      let click_coordinates_x = event.clientX;
      let click_coordinates_y = event.clientY;
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x,
        click_coordinates_y,
      });
    },
    openMobileCompatibleUrl(url) {
      if (!url) {
        return;
      }
      window.location.href = url;
    },
    async openOnlineService(event) {
      const click_coordinates_x = event.clientX;
      const click_coordinates_y = event.clientY;
      const userAgent = this.os.userAgent || "";
      landingPageClick(this, {
        tab_name: "在线客服",
        tab_key: "customer_service",
        click_coordinates_x,
        click_coordinates_y,
      });
      if (this.onlineServiceLoading) {
        return;
      }
      this.onlineServiceLoading = true;
      try {
        const res = await getCustomerServiceUrl({
          uid: this.$route.query.uid || getTraceId(),
          appId: APPID,
          deviceType: getDeviceType(userAgent),
          systemType: getSystemType(userAgent),
          systemVersion: getSystemVersion(userAgent),
        });
        const serviceUrl = res && res.data && res.data.data;
        if (serviceUrl) {
          this.openMobileCompatibleUrl(serviceUrl);
          return;
        }
        if (this.cChannel) {
          this.openMobileCompatibleUrl(this.cChannel);
          return;
        }
      } catch (error) {
        if (this.cChannel) {
          this.openMobileCompatibleUrl(this.cChannel);
          return;
        }
        console.log("get customer service url error:", error);
      } finally {
        this.onlineServiceLoading = false;
      }
    },
    jumpUrl(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.mobilePage {
  height: 100%;
  width: 100%;
  background-color: #000;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;

  .headerBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    padding: 0 16px;
    box-sizing: border-box;
    background: #000 url("./../../../assets/images/mobileB/header-bg.webp")
      no-repeat center top;
    background-size: 100% 100%;
    position: relative;
    z-index: 1;
    width: 100%;

    .logo {
      display: flex;
      align-items: center;
      gap: 7px;
      flex-shrink: 0;
      position: relative;
      z-index: 1;

      .logoIcon {
        width: 47px;
        height: 47px;
        background: url("./../../../assets/images/mobileB/app-icon.png")
          no-repeat center;
        background-size: contain;
        flex-shrink: 0;
      }

      .logoInfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 4px;
        min-width: 0;

        .logoName {
          color: #fff;
          font-size: 22px;
          font-weight: 700;
          line-height: 1;
          letter-spacing: 0.2px;
        }

        .logoSlogan {
          color: #fff;
          font-size: 10px;
          font-weight: 400;
          line-height: 1;
          white-space: nowrap;
          opacity: 0.95;
        }
      }
    }

    .headerLinks {
      display: flex;
      align-items: flex-start;
      gap: 17px;
      position: relative;
      z-index: 1;

      .linkItem {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        width: 24px;

        span {
          color: #fff;
          font-size: 10px;
          letter-spacing: 0.8px;
          line-height: 1;
          white-space: nowrap;
        }

        .telegram,
        .business,
        .channel,
        .customer {
          width: 24px;
          height: 24px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        .telegram {
          background-image: url("./../../../assets/images/mobileB/telegram.png");
        }
        .business {
          background-image: url("./../../../assets/images/mobileB/business.png");
        }
        .channel {
          background-image: url("./../../../assets/images/mobileB/channel.png");
        }
        .customer {
          background-image: url("./../../../assets/images/mobileB/customer.png");
        }
      }
    }
  }

  .banner-box {
    margin: 0 auto;
    position: relative;
    width: 100%;
    height: 211px;
  }

  .banner {
    width: 375px;
    height: 211px;
    background: url("./../../../assets/images/mobileB/banner.webp") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 0;
  }

  .ctaBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 35px;
    padding: 0 11px 0 11px;
    background: linear-gradient(90deg, #ff6f2e 0%, #fab341 100%);
    box-sizing: border-box;
    position: relative;

    .ctaText {
      color: #000;
      font-size: 12px;
      font-weight: 500;
      line-height: 23px;
      white-space: nowrap;
      overflow: hidden;
      flex: 1;
      min-width: 0;
    }

    .ctaBtn {
      width: 77px;
      height: 21px;
      margin-left: 8px;
      background: url("./../../../assets/images/mobileB/cta-btn.png") no-repeat;
      background-size: 100% 100%;
      flex-shrink: 0;
    }
  }

  .main {
    padding-bottom: calc(120px + env(safe-area-inset-bottom));
    box-sizing: border-box;
    background-color: #000;

    .sectionBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 343px;
      height: 37px;
      margin: 13px auto 0;
      padding: 0 5px;
      border-radius: 9px;
      background: #2d2c2f;
      box-sizing: border-box;

      .section {
        min-width: 49px;
        height: 29px;
        border-radius: 6px;
        color: #fab341;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
      }

      .sectionActive {
        background: #ff6f2e;
        color: #fff;
      }
    }

    .contentBox {
      width: 343px;
      height: 2301px;
      margin: 21px auto 0;
      background-color: #000;
      background-image: url("./../../../assets/images/mobileB/content.webp");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }

  .bottomBox {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 12px 32px calc(12px + env(safe-area-inset-bottom));
    box-sizing: border-box;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.85) 28%,
      #000 100%
    );

    .downBtn {
      width: 139px;
      height: 43px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      flex-shrink: 0;
    }

    .downBtnIos {
      background-image: url("./../../../assets/images/mobileB/down-btn-ios.png");
    }

    .downBtnAndroid {
      background-image: url("./../../../assets/images/mobileB/down-btn-android.png");
    }

    .downBtnSpare {
      min-width: 80px;
      height: 28px;
      padding: 0 12px;
      border-radius: 14px;
      background: rgba(255, 111, 46, 0.9);
      color: #fff;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .disclaimer {
      width: 311px;
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      line-height: 17px;
      text-align: center;
    }
  }

  .downloadIosAppStore {
    height: 36px;
    width: 284px;
    background: url("./../../../assets/images/mobileB/downloadIosAppStore.gif")
      no-repeat;
    background-size: 100% 100%;
    position: fixed;
    left: 0;
    bottom: calc(128px + env(safe-area-inset-bottom));
    z-index: 998;
    .close-btn {
      height: 20px;
      width: 20px;
      background: url("./../../../assets/images/mobileB/close.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      right: -10px;
      top: -10px;
    }
  }

  .androidOverlay {
    display: flex;
    align-items: center;
    justify-content: center;
    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobileB/android_tip.webp")
        no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;
      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }
}
.downTip {
  border-radius: 10px;
  padding: 18px;
  box-sizing: border-box;
  text-align: center;
  .downTipTitle {
    font-size: 18px;
    margin-bottom: 34px;
  }
  .downTipContent {
    white-space: nowrap;
    font-size: 15px;
  }
  .url {
    font-size: 15px;
    margin-top: 16px;
    text-align: left;
  }
  .downTipConfirm {
    font-size: 15px;
    width: 160px;
    height: 30px;
    border-radius: 40px;
    margin: 32px auto 0;
    color: #fff;
    background: #5b92ee;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
